// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: ボイス試聴
const AdminOpsVoicePreviewApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_voice_preview";

    const ExecAdminOpsVoicePreviewApi = async (tVoiceTypeId, talkText, stylePrompt) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { t_voice_type_id: tVoiceTypeId, talk_text: talkText, style_prompt: stylePrompt || "" }, timeout: 2 * 60 * 1000 });
    };

    return ExecAdminOpsVoicePreviewApi;
};

export default AdminOpsVoicePreviewApi;
